import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Te acostás con miedo porque sabés que el fuego vuelve a las 2 de la mañana', 'Llevás el antiácido en la cartera como compañero inseparable', 'Tu médico te dijo "tomá el omeprazol" y ya llevás años sin plan de salida', 'Tenés tos crónica, voz ronca y garganta con moco que nadie conecta con el estómago', 'Dejaste el tomate, el vino y el chocolate. Y el ardor sigue igual.', 'Cada solución mejoró un tiempo. Y después volvió todo.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-154">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-155" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-156">
        <div className="max-w-4xl mx-auto" data-id="element-157">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-158">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif]" data-id="element-159">
              ¿Cuántos años más vas a vivir con este fuego?
            </h2>
            <p className="text-xl text-gray-300 mb-4" data-id="element-160">
              Seguiste la dieta. Tomaste el omeprazol. Dejaste el tomate y el
              café.
            </p>
            <p className="text-xl text-gray-300 mb-4" data-id="element-161">
              Y el ardor vuelve igual.
            </p>
            <p className="text-xl text-brand-light font-medium" data-id="element-162">
              No es tu culpa. Es que nadie te dio el mapa completo.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-163">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-164">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-165" />
                <p className="text-lg text-gray-200" data-id="element-166">{point}</p>
              </motion.div>)}
          </div>

          
        </div>
      </div>
    </section>;
}